// extracted by mini-css-extract-plugin
export default {"button":"K2H9LEr4BF1NNllCiSwR"};